export const categories = [
  { slug: 'shaonian-rexue', name: '少年热血', description: '燃爆青春的战斗与冒险故事', count: 128, icon: 'ri-fire-line' },
  { slug: 'xiaoyuan-lianai', name: '校园恋爱', description: '甜蜜青涩的校园爱情物语', count: 96, icon: 'ri-heart-line' },
  { slug: 'xuanhuan-xiuzhen', name: '玄幻修真', description: '宏大世界观下的修炼传奇', count: 85, icon: 'ri-moon-line' },
  { slug: 'xuanyi-kehuan', name: '悬疑科幻', description: '烧脑谜题与未来科技的交织', count: 64, icon: 'ri-rocket-line' },
  { slug: 'gaoxiao-richang', name: '搞笑日常', description: '轻松欢乐的日常生活喜剧', count: 72, icon: 'ri-emotion-laugh-line' },
  { slug: 'guzhuang-wuxia', name: '古装武侠', description: '刀光剑影中的江湖恩仇', count: 53, icon: 'ri-sword-line' },
];

export const mangaList = [
  {
    id: 'mitao-shaonian',
    slug: 'mitao-shaonian',
    title: '蜜桃少年',
    author: '林小夏',
    cover: 'https://readdy.ai/api/search-image?query=Beautiful%20Chinese%20manga%20style%20illustration%20of%20a%20handsome%20teenage%20boy%20with%20soft%20peach%20colored%20hair%2C%20wearing%20a%20school%20uniform%2C%20standing%20under%20blooming%20peach%20blossom%20trees%2C%20warm%20golden%20sunlight%2C%20dreamy%20atmosphere%2C%20anime%20art%20style%2C%20soft%20pastel%20colors%2C%20clean%20lines%2C%20romantic%20mood%2C%20high%20quality%20illustration&width=800&height=1100&seq=manga-cover-01&orientation=portrait',
    description: '在蜜桃成熟的季节，少年林澈遇见了改变他命运的那个人。一段关于成长、友情与懵懂心动的故事，在这个夏天悄然展开。',
    category: '校园恋爱',
    updateStatus: '连载中',
    latestChapter: '第48话',
    updateTime: '2026-07-02',
    views: 1582000,
    rating: 9.6,
    tags: ['校园', '恋爱', '青春', '甜宠'],
    chapters: Array.from({ length: 48 }, (_, i) => ({
      id: `ch${i + 1}`,
      number: i + 1,
      title: i === 0 ? '相遇的夏天' : i === 47 ? '心的方向' : `第${i + 1}话`,
      updateTime: `2026-${String(Math.max(1, 7 - Math.floor(i / 10))).padStart(2, '0')}-${String(Math.max(1, 30 - i)).padStart(2, '0')}`,
      views: Math.floor(Math.random() * 50000) + 10000,
    })),
  },
  {
    id: 'xingkong-wuqu',
    slug: 'xingkong-wuqu',
    title: '星空舞曲',
    author: '陈墨白',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manga%20style%20illustration%20of%20a%20beautiful%20girl%20dancing%20under%20a%20starry%20night%20sky%2C%20her%20long%20dark%20hair%20flowing%2C%20wearing%20an%20elegant%20dance%20costume%2C%20surrounded%20by%20sparkling%20stars%20and%20constellations%2C%20ethereal%20atmosphere%2C%20anime%20art%20style%2C%20deep%20blue%20and%20silver%20tones%2C%20clean%20lines%2C%20dreamy%20mood&width=800&height=1100&seq=manga-cover-02&orientation=portrait',
    description: '少女林星辰有一个梦想——成为世界顶尖的芭蕾舞者。在追逐梦想的道路上，她遇到了志同道合的伙伴和意想不到的对手。',
    category: '校园恋爱',
    updateStatus: '连载中',
    latestChapter: '第36话',
    updateTime: '2026-07-01',
    views: 892000,
    rating: 9.3,
    tags: ['校园', '舞蹈', '励志', '恋爱'],
    chapters: Array.from({ length: 36 }, (_, i) => ({
      id: `ch${i + 1}`,
      number: i + 1,
      title: i === 0 ? '梦想的起点' : i === 35 ? '舞台之上' : `第${i + 1}话`,
      updateTime: `2026-${String(Math.max(1, 7 - Math.floor(i / 12))).padStart(2, '0')}-${String(Math.max(1, 28 - i)).padStart(2, '0')}`,
      views: Math.floor(Math.random() * 30000) + 8000,
    })),
  },
  {
    id: 'jiansheng-chuanqi',
    slug: 'jiansheng-chuanqi',
    title: '剑圣传奇',
    author: '独孤一剑',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manga%20style%20illustration%20of%20a%20powerful%20swordsman%20in%20traditional%20ancient%20Chinese%20clothing%2C%20holding%20a%20glowing%20sword%2C%20standing%20on%20a%20mountain%20peak%20at%20sunset%2C%20dramatic%20clouds%2C%20epic%20atmosphere%2C%20anime%20art%20style%2C%20warm%20golden%20and%20red%20tones%2C%20clean%20lines%2C%20heroic%20mood&width=800&height=1100&seq=manga-cover-03&orientation=portrait',
    description: '少年云逸本是平凡山村少年，意外获得上古剑圣传承，从此踏上了一条逆天改命的修炼之路。',
    category: '玄幻修真',
    updateStatus: '连载中',
    latestChapter: '第156话',
    updateTime: '2026-07-03',
    views: 3200000,
    rating: 9.5,
    tags: ['玄幻', '修真', '热血', '战斗'],
    chapters: Array.from({ length: 156 }, (_, i) => ({
      id: `ch${i + 1}`,
      number: i + 1,
      title: i === 0 ? '山村少年' : i === 155 ? '剑指苍穹' : `第${i + 1}话`,
      updateTime: `2026-${String(Math.max(1, 7 - Math.floor(i / 60))).padStart(2, '0')}-${String(Math.max(1, 31 - (i % 31))).padStart(2, '0')}`,
      views: Math.floor(Math.random() * 60000) + 20000,
    })),
  },
  {
    id: 'mofa-shaonu',
    slug: 'mofa-shaonu',
    title: '魔法少女小圆',
    author: '月见樱',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manga%20style%20illustration%20of%20a%20cute%20magical%20girl%20with%20pink%20twin%20tails%2C%20holding%20a%20magical%20wand%20with%20a%20star%20on%20top%2C%20surrounded%20by%20floating%20sparkles%20and%20ribbons%2C%20wearing%20a%20frilly%20magical%20dress%2C%20pastel%20background%2C%20anime%20art%20style%2C%20soft%20colors%2C%20kawaii%20aesthetic&width=800&height=1100&seq=manga-cover-04&orientation=portrait',
    description: '普通初中生小圆偶然获得变身魔法少女的能力，从此她的人生发生了天翻地覆的变化。但魔法少女的背后，隐藏着不为人知的秘密。',
    category: '玄幻修真',
    updateStatus: '连载中',
    latestChapter: '第24话',
    updateTime: '2026-06-30',
    views: 1260000,
    rating: 9.1,
    tags: ['魔法', '少女', '奇幻', '友情'],
    chapters: Array.from({ length: 24 }, (_, i) => ({
      id: `ch${i + 1}`,
      number: i + 1,
      title: i === 0 ? '命运的相遇' : i === 23 ? '最后的愿望' : `第${i + 1}话`,
      updateTime: `2026-${String(Math.max(1, 7 - Math.floor(i / 10))).padStart(2, '0')}-${String(Math.max(1, 25 - i)).padStart(2, '0')}`,
      views: Math.floor(Math.random() * 40000) + 15000,
    })),
  },
  {
    id: 'tiancai-wanjia',
    slug: 'tiancai-wanjia',
    title: '天才玩家',
    author: '雷火工作室',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manga%20style%20illustration%20of%20a%20cool%20teenage%20boy%20wearing%20a%20high-tech%20gaming%20headset%2C%20intense%20gaming%20expression%2C%20surrounded%20by%20holographic%20game%20interfaces%20and%20digital%20effects%2C%20cyber%20background%2C%20anime%20art%20style%2C%20neon%20colors%2C%20dynamic%20composition&width=800&height=1100&seq=manga-cover-05&orientation=portrait',
    description: '高中生叶修是网游《荣耀》中的传奇高手，但因种种原因被俱乐部驱逐。他重新开始，在网游中再度崛起，书写属于自己的巅峰之路。',
    category: '少年热血',
    updateStatus: '连载中',
    latestChapter: '第89话',
    updateTime: '2026-07-02',
    views: 4200000,
    rating: 9.8,
    tags: ['游戏', '电竞', '热血', '竞技'],
    chapters: Array.from({ length: 89 }, (_, i) => ({
      id: `ch${i + 1}`,
      number: i + 1,
      title: i === 0 ? '从头再来' : i === 88 ? '荣耀之巅' : `第${i + 1}话`,
      updateTime: `2026-${String(Math.max(1, 7 - Math.floor(i / 40))).padStart(2, '0')}-${String(Math.max(1, 30 - i)).padStart(2, '0')}`,
      views: Math.floor(Math.random() * 80000) + 30000,
    })),
  },
  {
    id: 'yexing-shenhua',
    slug: 'yexing-shenhua',
    title: '夜行神话',
    author: '猫腻',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manga%20style%20illustration%20of%20a%20mysterious%20young%20man%20in%20a%20dark%20alley%20at%20night%2C%20wearing%20a%20long%20black%20coat%2C%20moonlight%20casting%20shadows%2C%20urban%20fantasy%20setting%2C%20anime%20art%20style%2C%20dark%20and%20moody%20atmosphere%2C%20silver%20and%20black%20tones%2C%20clean%20lines&width=800&height=1100&seq=manga-cover-06&orientation=portrait',
    description: '都市传说中有一群夜间行走的超能力者，他们在黑暗中维护着人类世界的秩序。高中生林凡因一次意外，成为了他们中的一员。',
    category: '悬疑科幻',
    updateStatus: '连载中',
    latestChapter: '第62话',
    updateTime: '2026-07-01',
    views: 980000,
    rating: 9.2,
    tags: ['都市', '超能力', '悬疑', '战斗'],
    chapters: Array.from({ length: 62 }, (_, i) => ({
      id: `ch${i + 1}`,
      number: i + 1,
      title: i === 0 ? '午夜降临' : i === 61 ? '破晓时分' : `第${i + 1}话`,
      updateTime: `2026-${String(Math.max(1, 7 - Math.floor(i / 25))).padStart(2, '0')}-${String(Math.max(1, 28 - i)).padStart(2, '0')}`,
      views: Math.floor(Math.random() * 35000) + 12000,
    })),
  },
  {
    id: 'richang-qiji',
    slug: 'richang-qiji',
    title: '日常奇迹',
    author: '阿丸',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manga%20style%20illustration%20of%20a%20group%20of%20high%20school%20friends%20laughing%20together%20in%20a%20classroom%20filled%20with%20sunlight%2C%20casual%20school%20uniforms%2C%20warm%20and%20cheerful%20atmosphere%2C%20anime%20art%20style%2C%20soft%20warm%20colors%2C%20slice%20of%20life%20aesthetic&width=800&height=1100&seq=manga-cover-07&orientation=portrait',
    description: '四个性格迥异的高中生，在同一间教室里度过了三年的青春时光。看似平凡的日常，却是生命中最珍贵的奇迹。',
    category: '搞笑日常',
    updateStatus: '已完结',
    latestChapter: '第120话（完）',
    updateTime: '2026-06-15',
    views: 760000,
    rating: 9.4,
    tags: ['日常', '搞笑', '友情', '治愈'],
    chapters: Array.from({ length: 120 }, (_, i) => ({
      id: `ch${i + 1}`,
      number: i + 1,
      title: i === 0 ? '开学第一天' : i === 119 ? '永不结束的日常' : `第${i + 1}话`,
      updateTime: `2026-${String(Math.max(1, 6 - Math.floor(i / 50))).padStart(2, '0')}-${String(Math.max(1, 30 - (i % 30))).padStart(2, '0')}`,
      views: Math.floor(Math.random() * 20000) + 5000,
    })),
  },
  {
    id: 'jianghu-ling',
    slug: 'jianghu-ling',
    title: '江湖令',
    author: '凤歌',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manga%20style%20illustration%20of%20a%20martial%20arts%20hero%20in%20traditional%20hanfu%20robes%2C%20standing%20in%20a%20bamboo%20forest%20with%20falling%20leaves%2C%20holding%20a%20jade%20pendant%2C%20misty%20ancient%20Chinese%20landscape%2C%20anime%20art%20style%2C%20elegant%20ink%20wash%20tones%2C%20poetic%20mood&width=800&height=1100&seq=manga-cover-08&orientation=portrait',
    description: '一枚神秘的江湖令横空出世，引得天下豪杰纷纷出手。少年侠客沈清扬无意中卷入这场风波，在刀光剑影中悟出真正的侠义之道。',
    category: '古装武侠',
    updateStatus: '连载中',
    latestChapter: '第42话',
    updateTime: '2026-07-03',
    views: 1560000,
    rating: 9.7,
    tags: ['武侠', '古装', '江湖', '侠义'],
    chapters: Array.from({ length: 42 }, (_, i) => ({
      id: `ch${i + 1}`,
      number: i + 1,
      title: i === 0 ? '初入江湖' : i === 41 ? '侠之大者' : `第${i + 1}话`,
      updateTime: `2026-${String(Math.max(1, 7 - Math.floor(i / 18))).padStart(2, '0')}-${String(Math.max(1, 28 - i)).padStart(2, '0')}`,
      views: Math.floor(Math.random() * 45000) + 18000,
    })),
  },
];

export const getMangaBySlug = (slug: string) => mangaList.find(m => m.slug === slug) || null;

export const getMangaByCategory = (categorySlug: string) => {
  const cat = categories.find(c => c.slug === categorySlug);
  if (!cat) return [];
  return mangaList.filter(m => m.category === cat.name);
};

export const getPopularManga = (limit: number = 5) => {
  return [...mangaList].sort((a, b) => b.views - a.views).slice(0, limit);
};

export const getLatestUpdates = (limit: number = 6) => {
  return [...mangaList].sort((a, b) => new Date(b.updateTime).getTime() - new Date(a.updateTime).getTime()).slice(0, limit);
};

export const hotTags = ['蜜桃少年', '校园恋爱', '热血战斗', '玄幻修真', '古装武侠', '搞笑日常', '悬疑推理', '治愈系'];

export const reviews = [
  {
    id: 1,
    userName: '漫画爱好者小明',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20portrait%20of%20a%20young%20man%20avatar%2C%20simple%20clean%20style%2C%20warm%20smile%2C%20soft%20lighting%2C%20neutral%20background&width=100&height=100&seq=avatar-01&orientation=squarish',
    rating: 5,
    content: '蜜桃少年的画风真的太精美了！每一页都像艺术品一样，故事情节也超级吸引人，林澈和小夏的感情线让我这个老阿姨都少女心爆棚！',
    date: '2026-06-28',
  },
  {
    id: 2,
    userName: '深夜追漫人',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20portrait%20of%20a%20young%20woman%20avatar%2C%20simple%20clean%20style%2C%20gentle%20expression%2C%20soft%20lighting%2C%20neutral%20background&width=100&height=100&seq=avatar-02&orientation=squarish',
    rating: 5,
    content: '土豪漫画网的阅读体验真的很棒！下拉式阅读太方便了，不用频繁翻页，一口气看了几十话，根本停不下来。推荐给所有喜欢漫画的朋友！',
    date: '2026-06-25',
  },
  {
    id: 3,
    userName: '漫画评论家老王',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20portrait%20of%20a%20middle%20aged%20man%20avatar%2C%20simple%20clean%20style%2C%20friendly%20expression%2C%20soft%20lighting%2C%20neutral%20background&width=100&height=100&seq=avatar-03&orientation=squarish',
    rating: 4,
    content: '作为一个看了十几年漫画的老读者，土豪漫画网的漫画资源真的很全，蜜桃少年、剑圣传奇这些热门作品更新速度也快，五星好评！',
    date: '2026-06-20',
  },
  {
    id: 4,
    userName: '樱花飘落的季节',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20portrait%20of%20a%20young%20girl%20avatar%2C%20simple%20clean%20style%2C%20shy%20smile%2C%20soft%20lighting%2C%20neutral%20background&width=100&height=100&seq=avatar-04&orientation=squarish',
    rating: 5,
    content: '日常奇迹完结了我好舍不得啊！感谢土豪漫画网让我遇到了这么温暖的作品。希望作者能出番外篇！另外网站的界面很清爽，用起来很舒服。',
    date: '2026-06-18',
  },
  {
    id: 5,
    userName: '江湖故人',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20portrait%20of%20a%20young%20man%20with%20glasses%20avatar%2C%20simple%20clean%20style%2C%20thoughtful%20expression%2C%20soft%20lighting%2C%20neutral%20background&width=100&height=100&seq=avatar-05&orientation=squarish',
    rating: 4,
    content: '江湖令的画风和剧情都很对我胃口，更新速度也很快，每周都准时蹲更新。土豪漫画网的书架功能也很好用，收藏的漫画更新了会提醒。',
    date: '2026-06-15',
  },
];

export const aboutInfo = {
  brandName: '土豪漫画网',
  subBrand: '蜜桃少年漫画',
  introduction: '土豪漫画网是国内领先的在线漫画阅读平台，致力于为漫画爱好者提供最优质的阅读体验。我们拥有涵盖少年热血、校园恋爱、玄幻修真、悬疑科幻、搞笑日常、古装武侠等多元品类的中文漫画资源，采用创新的下拉式阅读技术，让读者享受如丝般顺滑的浏览体验。',
  mission: '我们的使命是让每一位漫画爱好者都能随时随地享受漫画带来的乐趣。无论你身在何处，打开土豪漫画网，就能进入属于你的漫画世界。',
  features: [
    { title: '海量资源', description: '数千部正版漫画作品，涵盖多个品类，满足不同读者的需求。', icon: 'ri-book-open-line' },
    { title: '下拉式阅读', description: '创新的下拉式阅读体验，告别频繁翻页，让阅读更加流畅自然。', icon: 'ri-file-list-line' },
    { title: '免费阅读', description: '所有漫画全部免费，无需付费订阅，真正让每个人都能享受漫画。', icon: 'ri-star-line' },
    { title: '极速更新', description: '与各大漫画平台同步更新，第一时间为读者带来最新章节。', icon: 'ri-flashlight-line' },
  ],
  stats: [
    { label: '漫画作品', value: '5,000+' },
    { label: '注册用户', value: '120万+' },
    { label: '日均阅读', value: '80万+话' },
    { label: '好评率', value: '98.6%' },
  ],
  contact: {
    email: 'hello@i2p1d.com',
    phone: '400-888-6666',
    address: '北京市朝阳区望京SOHO T2 12层',
    wechat: 'tuhaomanhua',
    weibo: '@土豪漫画网官方',
  },
};